import {createSlice} from '@reduxjs/toolkit'
import api from "../api";
import {VIEW_STATE} from "../utils/enums";

const slice = createSlice({
    name: 'courseCategory',
    initialState: {
        viewState: VIEW_STATE.LOADING,
        courseCategories: []
    },
    reducers: {
        setViewState: (state, action) => {
            state.viewState = action.payload
        },
        setCourseCategories: (state, action) => {
            state.courseCategories = action.payload
            state.viewState = VIEW_STATE.LOADED
        },
    },
});

export default slice.reducer
const {setViewState, setCourseCategories} = slice.actions

export const getCourseCategories = (parentId) => async dispatch => {
    try {
        dispatch(setViewState(VIEW_STATE.LOADING))
        const {data} = await api.courseCategory.getCourseCategories(parentId)
        dispatch(setCourseCategories(data?.data));
    } catch (e) {
        dispatch(setViewState(VIEW_STATE.ERROR))
    }
}
